export class LigneParametrage {

	id: number;
	code: string;
	designation: string;
	valeur: string;

	[x: string]: unknown;

	deserialize(input: any) {
		Object.assign(this, input);
		return this;
	}

}
